import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_2 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "dialog-footer"
};
import { ref, watch, watchEffect } from 'vue';
import { set_client_user } from '@/api/apis';
import { useUserStore } from '@/store/user';
import { ElMessage } from 'element-plus';
import { systemType } from '@/constants';
import _ from 'lodash';
import { phone_reg } from '@/util';
export default {
  __name: 'addContractDailog',
  props: ['id', 'isShow', 'info'],
  emits: ['close', 'onSetSuccess'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var ruleFormRef = ref(null);
    var default_client = {
      name: '',
      // 姓名
      avatar: '',
      // 头像
      gender: '',
      // 性别
      email: '',
      // 电子邮箱
      client_id: '',
      // 所属公司
      client_name: '',
      // 公司名称
      dept: '',
      // 部门
      address: '',
      // 地址
      role: '',
      // 角色
      phone: '',
      // 手机号码
      remark: '',
      // 说明
      province: '',
      // 省市区
      birthday: '',
      // 生日
      telephone: '',
      // 固话
      county: '' // 国家
    };
    var form = ref();
    form.value = Object.assign({}, default_client);
    // 表单验证方法
    function validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phone_reg(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    }
    var rules = {
      name: [{
        required: 'true',
        message: '请输入姓名',
        trigger: ['blur', 'change']
      }],
      phone: [{
        validator: validatePhone,
        required: true,
        trigger: "blur"
      }],
      client_name: [{
        required: 'true',
        message: '请选择客户',
        trigger: ['blur', 'change']
      }],
      email: [{
        required: 'true',
        message: '请输入电子邮箱',
        trigger: ['blur', 'change']
      }]
    };
    var dialogVisible = ref(false);
    var is_show_dialog = ref(false);
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    watch(() => {
      return dialogVisible.value;
    }, () => {
      if (!dialogVisible.value) {
        form.value = Object.assign({}, default_client);
        ruleFormRef.value.resetFields();
        emit('close');
      } else {
        props.info && init_from();
      }
    });

    /**
     * 获取省市区
     */

    // watch(
    //   () => {
    //     return form.value.birthday;
    //   },
    //   (val) => {
    //     console.log("获取的生日是", form.value.birthday);
    //   }
    // );
    /**
     * 上传头像
     */
    var action = process.env.VUE_APP_BASE_URL + '/api/file/add_file';
    var headers = {
      'system-type': systemType,
      Authorization: 'Bearer ' + localStorage.getItem('token_blk')
    };
    var imageUrl = ref('');
    var handleAvatarSuccess = (response, uploadFile) => {
      if (response.code == 200) {
        form.value.avatar = response.data.file_id;
        imageUrl.value = response.data.file_url;
      }
    };
    var beforeAvatarUpload = file => {
      var fileType = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1).toUpperCase() : '';
      if (fileType != 'JPG' && fileType != 'PNG') {
        // ElMessage.error("上传文件只能是JPG或者PNG格式!");
        ElMessage({
          type: 'error',
          message: '上传文件只能是JPG或者PNG格式'
        });
      }
      return fileType == 'JPG' || fileType == 'PNG';
    };
    var handleRemove = (uploadFile, files) => {};
    /**
     * 编辑客户，初始化数据
     */
    var init_from = () => {
      var _obj$client_info;
      var obj = _.cloneDeep(props.info);
      Object.keys(form.value).map(x => {
        if (obj.hasOwnProperty(x)) {
          form.value[x] = obj[x];
        }
      });
      form.value.client_name = (_obj$client_info = obj.client_info) === null || _obj$client_info === void 0 ? void 0 : _obj$client_info.company;
      imageUrl.value = obj.file_url;
    };
    watch(() => {
      return props.info;
    }, () => {
      if (!props.info) {
        form.value = Object.assign({}, default_client);
        imageUrl.value = '';
      } else {
        init_from();
      }
    });

    /**
     * 选择客户
     */
    var data_type = ref(''); // 进行选择数据的字段
    var select_data = val => {
      data_type.value = val;
      is_show_dialog.value = true;
    };
    var get_select_item = val => {
      is_show_dialog.value = false;
      if (data_type.value == '客户') {
        form.value.client_name = val.company;
        form.value.client_id = val.id;
      }
    };
    /**
     * 提交
     */
    var onSubmit = () => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          // form.value.salename = dic_data.sales_user_list.find(
          //   (x) => x.id == form.value.userid
          // )?.name;

          var obj = _.cloneDeep(form.value);
          var method = 'post';
          if (props.id) {
            method = 'put';
            obj.id = props.id;
          }
          set_client_user(obj, method).then(res => {
            if (res.code == 200) {
              ElMessage.success(props.id ? '编辑成功' : '新增成功');
              dialogVisible.value = false;
              emit('onSetSuccess');
            }
          });
        }
      });
    };
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_area_select = _resolveComponent("area-select");
      var _component_Plus = _resolveComponent("Plus");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_upload = _resolveComponent("el-upload");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_select_data = _resolveComponent("select-data");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => dialogVisible.value = $event),
        title: __props.id ? '编辑联系人' : '新增联系人',
        style: {
          "width": "700px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSubmit,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: form.value,
          "label-position": "right",
          "label-width": "100px",
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "姓名",
                prop: "name"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "手机号码",
                prop: "phone"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.phone = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[20] || (_cache[20] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户",
                prop: "client_name"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
                  modelValue: form.value.client_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.client_name = $event),
                  autocomplete: "off",
                  disabled: ""
                }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = $event => select_data('客户')),
                  color: "#248f83"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("选择")])),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "电子邮件",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.email = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[30] || (_cache[30] = _createElementVNode("div", {
            class: "title"
          }, "选填选项", -1)), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "部门"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.dept,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.dept = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "职位"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.role,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.role = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "性别"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.gender,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.gender = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "男",
                    value: "男"
                  }), _createVNode(_component_el_option, {
                    label: "女",
                    value: "女"
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "生日"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: form.value.birthday,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.birthday = $event),
                  type: "date",
                  placeholder: "",
                  format: "YYYY/MM/DD",
                  "value-format": "YYYY/MM/DD"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "固话"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.telephone,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.telephone = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "国家"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.county,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.county = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "省市区"
              }, {
                default: _withCtx(() => [_createVNode(_component_area_select, {
                  modelValue: form.value.province,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.province = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.address,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.address = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "上传头像"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  class: "avatar-uploader",
                  action: action,
                  headers: headers,
                  data: {
                    content_type: 1
                  },
                  "show-file-list": false,
                  "on-success": handleAvatarSuccess,
                  "before-upload": beforeAvatarUpload,
                  "on-remove": handleRemove
                }, {
                  default: _withCtx(() => [imageUrl.value ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: imageUrl.value,
                    class: "avatar"
                  }, null, 8, _hoisted_3)) : (_openBlock(), _createBlock(_component_el_icon, {
                    key: 1,
                    class: "avatar-uploader-icon"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_Plus)]),
                    _: 1
                  }))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "说明"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: form.value.remark,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.remark = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_select_data, {
        onClose: _cache[16] || (_cache[16] = $event => is_show_dialog.value = false),
        isShow: is_show_dialog.value,
        data_type: data_type.value,
        onOnSelectItem: get_select_item
      }, null, 8, ["isShow", "data_type"])]);
    };
  }
};